<form action="" class="hidden-form m2" enctype="multipart/form-data" style="display: none;">
  <input #fileUpload type="file" accept=".bib" (change)="onUpload($event)" class="btn" />
</form>

<div class="dca-heading flex items-center justify-between px2" aria-label="reference">
  <div class="h2 flex items-center">
    <span>References</span>
  </div>

  <div class="flex items-center">
    <!-- <button mat-icon-button aria-label="search" (click)="search()">
      <mat-icon>search</mat-icon>
    </button> -->
    <button mat-icon-button matTooltip="Upload bib file" (click)="uploadReferenceFile()">
      <mat-icon>playlist_add</mat-icon>
    </button>
    <!-- <button mat-icon-button matTooltip="Edit References" (click)="editReferences()">
      <mat-icon>edit</mat-icon>
    </button> -->
  </div>
</div>
<div class="flex">
  <div class="flex flex-column ">
    @if (referenceList$ | async; as references) {
      @if (references.length > 0) {
        <div
          class="reference-list dca-scrollarea flex-column dca-width overflow-y-auto items-baseline"
        >
          @for (reference of references; track reference.key) {
            <div
              class="citation-card p2 cursor-pointer"
              [attr.data-reference-id]="reference.csl?.id || reference.key"
              [ngClass]="{
              'mat-elevation-z1': reference.citationsfromEditor,
              'selected': isReferenceSelected(reference)
            }"
              (click)="selectReference(reference)"
            >
              <div class="flex items-center justify-between mxn1">
                <div
                  class="px1 flex"
                  [draggable]="!(isMaximized$() )"
                  [matTooltip]="(isMaximized$() ) ? '' : 'drag reference into document'"
                  (dragstart)="onDragStart($event, reference)"
                >
                  <div class="draggable" [ngClass]="{ 'disabled': (isMaximized$()) }"></div>
                  <div class="ml1 flex-auto">
                    <p class="m0 reference-content">
                      @if (!reference.csl?._meta?.reviewed) {
                        <sfo-reference-source-badge
                          [source]="getReferenceSourceClass(reference)"
                        ></sfo-reference-source-badge>
                      }
                      <span class="reference-main">
                        @if (!reference.citationsfromEditor && reference.csl) {
                          <mat-icon class="warning" matTooltip="Not yet cited in document">
                            warning_amber
                          </mat-icon>
                        }
                        <span class="reference-text">
                          @if (reference.csl?.rawCitation) {
                            <span [innerHTML]="reference.csl.rawCitation"></span>
                          } @else {
                            {{ reference.bib || reference.csl.title || 'No title available' }}
                          }
                        </span>
                      </span>
                    </p>
                  </div>
                  @if (!isMaximized$()) {
                    <div class="flex flex-column justify-center items-center">
                      <button
                        matIconButton
                        (click)="editReference(reference, $event)"
                        aria-label="Edit reference"
                        matTooltip="Edit reference"
                      >
                        <mat-icon>{{ reference.csl ? 'edit' : 'edit_note' }}</mat-icon>
                      </button>
                    </div>
                  }
                </div>
                <!-- <div class="px1 flex flex-column"> -->
                <!--  <button mat-icon-button aria-label="Calendar">
                <mat-icon>calendar_today</mat-icon>
              </button> -->
                <!-- <button mat-icon-button aria-label="Delete">
                <mat-icon>delete</mat-icon>
              </button> -->
                <!-- </div> -->
              </div>
              @if (reference.citationsfromEditor) {
                <mat-expansion-panel class="mat-elevation-z0 mt2">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Citations in text </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div>
                    <mat-list dense>
                      @for (
                        citations of reference.citationsfromEditor;
                        track citations.id;
                        let i = $index
                      ) {
                        <mat-list-item class="citation-in-text-item">
                          <button
                            mat-stroked-button
                            type="button"
                            class="citation-in-text-button"
                            (click)="editCitationInText(citations, $event)"
                          >
                            <span class="citation-in-text-label">
                              {{ i + 1 }}. {{ citations.textContent }}
                            </span>
                            <span class="citation-in-text-action">
                              <mat-icon>open_in_new</mat-icon>
                              <span>Open</span>
                            </span>
                          </button>
                        </mat-list-item>
                      }
                    </mat-list>
                  </div>
                </mat-expansion-panel>
              }
            </div>
          }
        </div>
      } @else {
        <div class="p2">
          <h3>Upload your references</h3>
          <p>
            The editor is able to format citations automatically when the document is being
            exported. To do that, it needs to learn about your references.
          </p>
          <a (click)="uploadReferenceFile()" class="uppercase">Upload .bib File</a>
          <a href="#" class="ml2 uppercase">Learn more</a>
        </div>
      }
    }
  </div>
  @if (isMaximized$()) {
    <div class="dca-scrollarea flex flex-column flex-auto items-center">
      @if (activeReference()) {
        <sfo-reference-editor
          [reference]="activeReference()"
          (updateReference)="updateReference($event)"
        ></sfo-reference-editor>
      } @else {
        <div class="p2">
          <h3>Select a reference to edit</h3>
          <p>
            Click on a reference to view and edit its details. You can also drag and drop a
            reference into the document to create a citation.
          </p>
        </div>
      }
    </div>
  }
</div>
